import * as React from "react";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import GalleryService from "../../services/gallery";
import { DANH_MUC } from "../../const/danh-muc";
import ContentComponent from "../share/ContentComponent";
import { loadImage } from "../../util/image";
import SpinnersVideo from "../share/Spinners/SpinnersVideo";
import Image from "../share/Image";
import Link from "next/link";
import { GALLERY_VARIABLE } from "../../const/gallery";
import { GALLERY } from "../../const/seo-url";
import { formatUrlSeo } from "../../util/seo-url";
import { GALLERY_HINH } from "../gallery/util";
import SpinnersImageText from "../share/Spinners/SpinnersImageText";

export default class ThuVienHinhAnhPhongThong extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      danhMucActive: DANH_MUC.HINH_ANH_PHO_THONG_HĐVH,
      danhSachGalleryHinhAnh: [],
    };
  }

  componentDidMount() {
    this.getData(DANH_MUC.HINH_ANH_PHO_THONG_HĐVH);
  }

  getData(danhMuc) {
    this.setState({
      loading: true,
    });
    GalleryService.getList(danhMuc, "h", 1, 3).then((value) => {
      if (value && value.galleries && value.galleries.length > 0) {
        value.galleries.forEach((x) => {
          x["hinh_goc"] =
            x.loai == GALLERY_VARIABLE.VIDEO
              ? x.hinh_dai_dien
              : x.hinh_dai_dien!.path;
          if (x.loai == GALLERY_VARIABLE.VIDEO) {
            x["url_chi_tiet"] =
              "/" +
              GALLERY.CHI_TIET_GALLERY_VIDEO +
              "/" +
              formatUrlSeo(x.url!, x.gallery_id!);
          }
          if (x.loai == GALLERY_VARIABLE.HINH) {
            try {
              let album: any[] = JSON.parse(x.data!.files);
              let files = album.map((x) => {
                return Object.assign({}, x, {
                  path: loadImage(x.path),
                });
              });

              x["album"] = GALLERY_HINH.getSizeImage(files, x.tieu_de);
            } catch (ex) {
              x["album"] = [];
            }
          }
        });
      }
      this.setState({
        loading: false,
        danhSachGalleryHinhAnh: value.galleries,
        danhMucActive: danhMuc,
      });
    });
  }

  onTab(id) {
    if (id == "mamnonhoatdongvuihoc") {
      this.getData(DANH_MUC.HINH_ANH_PHO_THONG_HĐVH);
    }
    if (id == "mamnonsukien") {
      this.getData(DANH_MUC.HINH_ANH_PHO_THONG_SU_KIEN);
    }
    if (id == "mamnonthamquan") {
      this.getData(DANH_MUC.HINH_ANH_PHO_THONG_THAM_QUAN);
    }
  }

  openDetail = (gallery) => {
    if (gallery.loai == GALLERY_VARIABLE.VIDEO) {
      window.location.href = gallery.url_chi_tiet;
    }
    if (gallery.loai == GALLERY_VARIABLE.HINH) {
      if (gallery.album.length === 0) {
        alert("Không có albuml của hình này");
        return;
      }
      this.setState({
        album: gallery.album,
        open_hinh: true,
      });
    }
  };

  buildContent() {
    if (this.state.loading) {
      return <div></div>;
    }
    if (this.state.danhSachGalleryHinhAnh.length == 0) {
      return <div style={{padding:'1rem'}}>No data</div>;
    }
    if (this.state.danhSachGalleryHinhAnh.length > 0) {
      return this.state.danhSachGalleryHinhAnh.map((value, index) => (
        <div
          className="col-xs-6 col-md-4 col-sm-4 thumb-video"
          onClick={() => this.openDetail(value)}
          key={value.id}
        >
          <div className="img">
            <Image
              className="img-fluid thumb"
              usefileurl={true}
              alt={value.tieu_de}
              src={value.hinh_dai_dien!.path}
              classPlaceHolder="lazy-image-gallery"
            />
          </div>
          <div className="textvideo trimtext">
            <span className="text-bold">{value.tieu_de}</span>
          </div>
        </div>
      ));
    }
  }
  loading() {
    if (this.state.loading) {
      return <SpinnersImageText type={"placeholde"} loading={true} />;
    }
  }

  render() {
    return (
      <React.Fragment>
        <ContentComponent content={this.props.content} />
        <div className="block back-gray">
          <div className="container">
            <div className="row" style={{ margin: "0px" }}>
              <div className="col-sm-12 text-left ">
                <b
                  style={{
                    borderLeft: "5px solid #ff0000",
                    padding: "0 10px",
                  }}
                >
                  PHOTOS
                </b>
              </div>
            </div>
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12 pl-0 pr-0 pt-3">
                {/* tab */}
                <ul className="nav nav-tabs ">
                  <li className="nav-item">
                    <a
                      data-target="#phothonghoatdongvuihoc"
                      data-toggle="tab"
                      className="nav-link active show"
                      onClick={() => this.onTab("phothonghoatdongvuihoc")}
                    >
                      LEARNING ACTIVITIES
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-target="#phothongsukien"
                      data-toggle="tab"
                      className="nav-link"
                      onClick={() => this.onTab("phothongsukien")}
                    >
                      EVENTS
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-target="#phothongthamquan"
                      data-toggle="tab"
                      className="nav-link "
                      onClick={() => this.onTab("phothongthamquan")}
                    >
                      SCHOOL TRIPS
                    </a>
                  </li>
                </ul>
                {/* Nội dung */}
                <div className="tab-content ">
                  <div
                    className="tab-pane container active show"
                    id="phothonghoatdongvuihoc"
                  >
                    {this.loading()}
                    <div className="row">
                      {this.buildContent()}
                      <div className="col-12 text-right">
                      <a href={ "/photos/album?album=" + this.state.danhMucActive} className="text-red text-bold">
                          {" "}
                          <i
                            className="fa fa-plus-square fa-1 text-red"
                            aria-hidden="true"
                          />{" "}
                          See all{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
